<template>
  <v-form ref="form">
    <v-row class="pb-8">
      <v-col cols="12">
        <p class="primary--text form__title mb-5">
          DADOS DO USUÁRIO
        </p>
      </v-col>
      <v-col cols="12" sm="8" class="pr-sm-5">
        <BaseFormInput
          id-element="userName"
          placeholder="Inserir"
          v-model="user.nome"
          validate-on-blur
          required
          :rules="[requiredInput]"
          label-text="Nome do Usuário"
        />
      </v-col>
      <v-col cols="12" sm="4">
        <BaseFormInput
          id-element="userPhone"
          placeholder="Inserir"
          v-model="user.telefone"
          validate-on-blur
          required
          :rules="[requiredInput, isValidPhoneNumber]"
          v-facade="maskPhone"
          label-text="Telefone"
        />
      </v-col>
      <v-col cols="12" class="pt-4">
        <v-divider />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <p class="primary--text form__title mb-5">
          DADOS DE ACESSO
        </p>
      </v-col>
      <v-col cols="12" class="mb-5" v-if="userId">
        <v-switch
          v-model="user.ativo"
          class="pa-0 ma-0 justify-self-center d-inline-block base-form-switch"
          dense
          inset
          hide-details
          color="secondary"
        />
        <p class="pl-1 mb-0 d-inline-block darkBluishGray--text body-2">
          Status: {{ statusText }}
        </p>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="5" md="4" class="pr-sm-5">
        <BaseFormInput
          id-element="userEmail"
          placeholder="Inserir"
          v-model="user.email"
          validate-on-blur
          required
          :rules="[requiredInput, isValidEmail]"
          label-text="Login/E-mail"
          :upper-case="false"
        />
      </v-col>
    </v-row>
    <v-row class="pb-8">
      <fragment v-if="userId">
        <v-col cols="12" sm="4" md="3" class="pr-sm-5">
          <BaseFormInput
            id-element="userLastAccessDate"
            v-model="user.data_ultimo_acesso"
            :rules="[dateTermValid]"
            label-text="Data do Último Acesso"
            v-facade="maskDate"
            disabled
          />
        </v-col>
        <v-col cols="12" sm="4" md="3" class="pr-sm-5">
          <BaseFormInput
            id-element="userBlockDate"
            v-model="user.data_bloqueio"
            :rules="[dateTermValid]"
            label-text="Data do Bloqueio"
            v-facade="maskDate"
            disabled
          />
        </v-col>
        <v-col cols="12" sm="4" md="3" class="pr-md-5">
          <BaseFormInput
            id-element="userReactivationDate"
            v-model="user.data_reativacao"
            :rules="[dateTermValid]"
            label-text="Data de Reativação"
            v-facade="maskDate"
            disabled
          />
        </v-col>
        <v-col cols="12" sm="4" md="3" class="pr-sm-5 pr-md-0">
          <BaseFormInput
            id-element="userCreationDate"
            v-model="user.criado_em"
            label-text="Data de Criação"
            v-facade="maskDate"
            disabled
          />
        </v-col>
      </fragment>
      <v-col cols="12" class="pt-4">
        <v-divider />
      </v-col>
    </v-row>
    <div class="pb-8">
      <v-row v-if="structureOptions.length && profileOptions.length">
        <v-col cols="12">
          <p class="primary--text form__title mb-5">
            PERFIL
          </p>
        </v-col>
        <v-col cols="12" sm="4" class="pr-sm-5" v-if="userAreaIsGeral">
          <BaseFormSelect
            placeholder="Selecione"
            :items="areaOptions"
            v-model="user.area_usuario"
            item-text="nome"
            item-value="id"
            :return-object="true"
            label-text="Área de Negócio"
            required
            :rules="[requiredInput]"
            @change="filterProfileOptions"
          />
        </v-col>
        <v-col cols="12" sm="4" class="pr-sm-5">
          <BaseFormSelect
            placeholder="Selecione"
            :items="structureOptions"
            v-model="user.estrutura"
            item-text="nome"
            item-value="id"
            :return-object="true"
            label-text="Estrutura de Acesso"
            required
            :rules="[requiredInput]"
            @change="filterProfileOptions"
          />
        </v-col>
        <v-col cols="12" sm="4" class="pr-sm-5">
          <BaseFormSelect
            placeholder="Selecione"
            :items="profileOptions"
            v-model="user.perfil"
            item-text="nome"
            item-value="id"
            :return-object="true"
            label-text="Perfil"
            required
            :rules="[requiredInput]"
          />
        </v-col>
        <v-col cols="12" sm="4" v-if="user.estrutura.id === 'funcionario'">
          <BaseFormSelect
            placeholder="Selecione"
            :items="typeProfileOptions"
            v-model="user.posicao"
            item-text="nome"
            item-value="id"
            :return-object="true"
            label-text="Responsável"
            required
            :rules="[requiredInput]"
          />
        </v-col>
      </v-row>
      <v-row v-if="user.estrutura.id === 'funcionario' && userId">
        <v-col cols="12" sm="3">
          <BaseButton
            v-html="'CARTEIRA'"
            class="secondary font-weight-bold"
            width="100%"
            @click="goToWallet()"
          />
        </v-col>
      </v-row>
      <v-row v-if="user.estrutura.id === 'cliente'">
        <v-col cols="12" sm="8" class="pr-sm-5">
          <BaseFormAutocomplete
            placeholder="Selecione"
            multiple
            v-model="user.grupos_economicos"
            label-text="Grupo Econômico"
            :items="economicGroupOptions"
            required
            :rules="[requiredInput]"
            item-text="nome"
            item-value="id"
            :return-object="true"
            @change="getOfficeOptions"
          />
        </v-col>
        <v-col cols="12" sm="4">
          <BaseFormSelect
            placeholder="Nenhum"
            :items="officeOptions"
            v-model="user.escritorio"
            item-text="nome_fantasia"
            item-value="id"
            :return-object="true"
            label-text="Escritório"
          />
        </v-col>
        <v-col cols="12" sm="4" v-if="userRequester">
          <BaseFormSelect
            placeholder="Nenhum"
            :items="approversList"
            v-model="user.aprovadores"
            item-text="nome"
            item-value="id"
            multiple
            :return-object="true"
            label-text="Aprovadores Responsáveis"
          />
        </v-col>
        <v-col cols="12" sm="4" v-if="userApprover">
          <BaseFormSelect
            placeholder="Nenhum"
            :items="approversList"
            v-model="user.solicitantes"
            item-text="nome"
            item-value="id"
            :return-object="true"
            multiple
            label-text="Aprovador dos Solicitantes"
          />
        </v-col>
      </v-row>
      <v-row v-if="activeEconomicGroups.length > 0">
        <v-col cols="12" class="pt-4">
          <v-divider />
        </v-col>
        <v-col cols="12" class="pt-8">
          <p class="primary--text form__title mb-5">
            PERMISSÕES
          </p>
        </v-col>
        <v-col>
          <BaseDataTable
            :headers="tableHeadersEconomicGroup"
            :items="activeEconomicGroups"
            no-data-text="Não há grupos econômicos vinculados."
            dense
          >
            <template v-slot:[`item.nome`]="{ item }">
              <v-row>
                <v-col style="line-height:40px">
                  {{ item.nome }}
                </v-col>
                <v-col class="d-flex justify-sm-end">
                  <v-tooltip left>
                    <template v-slot:activator="{ on }">
                      <div v-on="on">
                        <BaseButton
                          color="secondary"
                          class="px-0 mr-2"
                          @click="openModal(item)"
                          :disabled="!initiallyActiveGroups.includes(item)"
                        >
                          <v-icon>
                            $vuetify.icons.permissions
                          </v-icon>
                        </BaseButton>
                      </div>
                    </template>
                    <span>
                      {{
                        initiallyActiveGroups.includes(item)
                          ? "Editar Permissões"
                          : "Salve as Alterações Primeiro"
                      }}
                    </span>
                  </v-tooltip>
                </v-col>
              </v-row>
            </template>
          </BaseDataTable>
        </v-col>
      </v-row>
    </div>
    <ModalityPermissionsModal
      v-if="permissionsModal"
      v-model="permissionsModal"
      @close="closeModal"
      :economicGroupId="selectedEconomicGroup.id"
      :targetAPI="'usuarios'"
      :targetId="this.user.id"
    />
    <BaseFooter>
      <v-row>
        <v-spacer />
        <v-col cols="12" sm="3" class="mr-sm-5 pb-5 pb-sm-0">
          <BaseButton
            v-html="'CANCELAR'"
            class="error font-weight-bold"
            width="100%"
            :to="{ name: 'user' }"
          />
        </v-col>
        <v-col cols="12" sm="3">
          <BaseButton
            v-html="submitText"
            class="secondary font-weight-bold"
            width="100%"
            @click="submit"
          />
        </v-col>
      </v-row>
    </BaseFooter>
  </v-form>
</template>

<script>
import ModalityPermissionsModal from "@/modules/office/components/ModalityPermissionsModal.vue";
import {
  requiredInput,
  isValidPhoneNumber,
  isValidEmail,
  dateTermValid
} from "@/utils/rules.js";
import { maskPhone, maskDate } from "@/utils/masks.js";
import { mapState } from "vuex";

const tableHeadersEconomicGroup = [
  { text: "Grupo Econômico", value: "nome", sortable: true }
];

export default {
  name: "UserForm",
  components: { ModalityPermissionsModal },
  props: {
    user: {
      type: Object,
      default: null
    },
    userId: {
      type: String,
      default: ""
    },
    profileOptions: {
      type: Array,
      default: null
    },
    structureOptions: {
      type: Array,
      default: null
    },
    areaOptions: {
      type: Array,
      default: null
    },
    economicGroupOptions: {
      type: Array,
      default: null
    },
    officeOptions: {
      type: Array,
      default: null
    },
    typeProfileOptions: {
      type: Array,
      default: null
    },
    approversList: {
      type: Array
    }
  },
  data: () => ({
    requiredInput,
    isValidPhoneNumber,
    isValidEmail,
    dateTermValid,
    maskDate,
    maskPhone,
    tableHeadersEconomicGroup,
    permissionsModal: false,
    initiallyActiveGroups: { type: Array }
  }),
  created() {
    this.initiallyActiveGroups = this.activeEconomicGroups;
    this.user.area_usuario = this.myInfo.area_usuario;
  },
  computed: {
    ...mapState("me", ["myInfo", "userAreaIsGeral"]),
    statusText() {
      return this.user.ativo ? "Ativo" : "Inativo";
    },
    submitText() {
      return this.userId ? "SALVAR" : "ADICIONAR";
    },
    userRequester() {
      return this.user.perfil?.papel_principal?.id == "solicitante";
    },
    userApprover() {
      return this.user.perfil?.papel_principal?.id == "aprovador";
    },
    activeEconomicGroups() {
      let result = [];

      if (this.user.grupos_economicos != null) {
        for (let i = 0; i < this.economicGroupOptions.length; i++) {
          for (let j = 0; j < this.user.grupos_economicos.length; j++) {
            if (
              this.user.grupos_economicos[j].id ==
              this.economicGroupOptions[i].id
            ) {
              if (this.user.grupos_economicos[j].ativo) {
                result.push(this.economicGroupOptions[i]);
              }
              break;
            }
          }
        }
      }

      return result;
    }
  },
  methods: {
    filterProfileOptions() {
      this.$emit("filter-profile", this.user);
    },
    getOfficeOptions() {
      this.$emit("get-offices");
    },
    submit() {
      if (this.$refs.form.validate()) this.$emit("submit-user");
    },
    goToWallet() {
      this.$emit("go-wallet");
    },
    closeModal() {
      this.permissionsModal = false;
    },
    openModal(item) {
      this.selectedEconomicGroup = item;
      this.permissionsModal = true;
    }
  }
};
</script>
